"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appDownloads = exports.socialList = exports.supportNav = exports.legalNav = exports.companyNav = void 0;
exports.companyNav = [
    { link: "https://campgladiator.com/about", text: "About Us" },
    {
        link: "https://campgladiator.com/mission-and-story",
        text: "Mission & History",
    },
    { link: "https://campgladiator.com/cg-gives", text: "CG Gives" },
    { link: "https://cgvictory.org/", text: "CG Victory" },
    { link: "https://campgladiator.com/careers", text: "Careers" },
];
exports.legalNav = [
    { link: "https://campgladiator.com/terms", text: "Terms & Conditions" },
    { link: "https://campgladiator.com/privacy-policy", text: "Privacy Policy" },
    {
        link: "https://account.campgladiator.com/#/return-policy",
        text: "Return Policy",
    },
];
exports.supportNav = [
    { link: "https://support.campgladiator.com/", text: "FAQ" },
    { link: "https://campgladiator.com/contact", text: "Contact" },
];
exports.socialList = [
    {
        icon: "icon-facebook-line",
        title: "Facebook Page",
        link: "https://www.facebook.com/CampGladiator/",
    },
    {
        icon: "icon-twitter-line",
        title: "Twitter Profile",
        link: "https://twitter.com/campgladiator",
    },
    {
        icon: "icon-instagram-line",
        title: "Instagram Profile",
        link: "https://www.instagram.com/campgladiator/",
    },
    {
        icon: "icon-youtube-line",
        title: "YouTube Channel",
        link: "https://www.youtube.com/user/CampGladiator",
    },
];
exports.appDownloads = [
    {
        link: "https://apps.apple.com/us/app/camp-gladiator/id648465971?itsct=apps_box&amp;itscg=30200",
        name: "Download on the App Store",
        image: "https://cgcdn.s3.amazonaws.com/global-ui/images/apps/app-store--on-dark.svg",
    },
    {
        link: "https://play.google.com/store/apps/details?id=com.campgladiator&hl=en_US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        name: "Get it on Play Store",
        image: "https://cgcdn.s3.amazonaws.com/global-ui/images/apps/google-play--on-dark.svg",
    },
];
//# sourceMappingURL=footerData.js.map